import debug from "debug";
import { autobind } from "@bonliva-crm/common";
import { CustomerContractProfileLocation } from "@contracts/locations/CustomerContractProfileLocation";
import { TravelConfirmationViewLocation } from "@bookings/BookingHospitality/locations/TravelConfirmationViewLocation";
import { AccommodationConfirmationViewLocation } from "@bookings/BookingHospitality/locations/AccommodationConfirmationViewLocation";
import { NavigationManager } from "../navigation/NavigationManager";

const log = debug("app:MessagingStore");

export interface NavigateToCustomerContractCommand {
  key: "navigateToCustomerContract";
  contractId: string;
}

export interface NavigateToTravelConfirmationViewCommand {
  key: "navigateToTravelConfirmationView";
  bookingId: string;
  confirmationId: string;
}

export interface NavigateToAccommodationConfirmationViewCommand {
  key: "navigateToAccommodationConfirmationView";
  bookingId: string;
  confirmationId: string;
}

function isMessage<T>(ev: MessageEvent, key: string): ev is MessageEvent<T> {
  return ev.data.key === key;
}

/**
 * Handles cross-window communication
 */
export class MessagingStore {
  constructor(private readonly _navManager: NavigationManager) {
    autobind(this);

    window.addEventListener("message", (ev) => {
      log("received message %O", ev.data);

      if (
        isMessage<NavigateToCustomerContractCommand>(ev, "navigateToCustomerContract")
      ) {
        _navManager.open(
          "ext_customer_contract",
          new CustomerContractProfileLocation(ev.data.contractId)
        );
      }

      if (
        isMessage<NavigateToTravelConfirmationViewCommand>(
          ev,
          "navigateToTravelConfirmationView"
        )
      ) {
        _navManager.open(
          "ext_travel_confirm_view",
          new TravelConfirmationViewLocation({
            bookingId: ev.data.bookingId,
            confirmationId: ev.data.confirmationId
          })
        );
      }

      if (
        isMessage<NavigateToAccommodationConfirmationViewCommand>(
          ev,
          "navigateToAccommodationConfirmationView"
        )
      ) {
        _navManager.open(
          "ext_accomm_confirm_view",
          new AccommodationConfirmationViewLocation({
            bookingId: ev.data.bookingId,
            confirmationId: ev.data.confirmationId
          })
        );
      }
    });
  }
}
